export default __webpack_public_path__ + "static/media/Monopattino1.731d3797.jpeg";